export default __webpack_public_path__ + "static/media/ubs-logo.b4f82791.jpeg";